import type { RatingEnum } from '~/schema/public';
import type { ClappForGameMutationMutationFn } from '../ClappForGameMutation.generated';
import type {
  ClappsFragment,
  MyClappsFragment,
} from '../ClappsQuery.generated';

type Props = {
  rating: Maybe<RatingEnum>;
  gameId: string;
  myPreviousClapps: MyClappsFragment;
  previousAllClapps: ClappsFragment;
  clappForGame: ClappForGameMutationMutationFn;
};

const onClappForGame = async ({
  rating,
  gameId,
  myPreviousClapps,
  previousAllClapps,
  clappForGame,
}: Props) => {
  const vote = await clappForGame({
    variables: { input: { rating, gameId } },
    optimisticResponse: {
      casinoVoteForGame: {
        myClapps: {
          ...myPreviousClapps,
          myRating: rating,
        },
        allClapps: {
          ...previousAllClapps,
          ...createOptimisticAllClapps(rating, previousAllClapps),
        },
        __typename: 'CasinoVoteForGamePayload',
      },
      __typename: 'Mutation',
    },
  });
  if (vote?.data?.casinoVoteForGame) {
    const { myClapps, allClapps } = vote.data.casinoVoteForGame;
    return !!myClapps || !!allClapps;
  }
  return false;
};

const createOptimisticAllClapps = (
  rating: Props['rating'],
  previousAllClapps: Props['previousAllClapps'],
) => {
  const clapps = previousAllClapps.clapps ?? 0;
  if (rating === 'LIKE') {
    return { clapps: clapps + 1 };
  }
  return { clapps: clapps - 1 };
};

export default onClappForGame;
